class OveliscoHeader extends HTMLElement {
  connectedCallback() {
    const desktopMedia = window.matchMedia('(min-width: 750px)');

    const mobileToggle = this.querySelector(
      '[data-ovelisco-mobile]'
    );

    const mobilePanel = this.querySelector(
      '[data-ovelisco-mobile-panel]'
    );

    const openDesktopMenu = (button) => {
      if (!desktopMedia.matches) return;

      const panelId = button.getAttribute('aria-controls');
      const panel = this.querySelector(`#${panelId}`);

      this.closeAll();

      if (panel) {
        button.setAttribute('aria-expanded', 'true');
        panel.hidden = false;

        document.documentElement.classList.add(
          'ovelisco-menu-open'
        );
      }
    };

    this.querySelectorAll('[data-ovelisco-menu]').forEach((button) => {
      button.addEventListener('click', () => {
        const panelId = button.getAttribute('aria-controls');
        const panel = this.querySelector(`#${panelId}`);

        const wasOpen =
          button.getAttribute('aria-expanded') === 'true';

        this.closeAll();

        if (!wasOpen && panel) {
          button.setAttribute('aria-expanded', 'true');
          panel.hidden = false;

          document.documentElement.classList.add(
            'ovelisco-menu-open'
          );
        }
      });

      button.addEventListener('pointerenter', () => {
        openDesktopMenu(button);
      });
    });

    this.querySelectorAll('.ov-nav > a').forEach((link) => {
      link.addEventListener('pointerenter', () => {
        if (desktopMedia.matches) {
          this.closeAll();
        }
      });
    });

    this.querySelectorAll('[data-ovelisco-close]').forEach((item) => {
      item.addEventListener('click', () => {
        this.closeAll();
      });
    });

    this.querySelectorAll('.ov-mega__content').forEach((panel) => {
      panel.addEventListener('mouseleave', () => {
        if (desktopMedia.matches) {
          this.closeAll();
        }
      });
    });

    this.querySelectorAll('.ovelisco-mega a').forEach((link) => {
      link.addEventListener('click', () => {
        this.closeAll();
      });
    });

    mobileToggle?.addEventListener('click', (event) => {
      const expanded =
        event.currentTarget.getAttribute('aria-expanded') === 'true';

      event.currentTarget.setAttribute(
        'aria-expanded',
        String(!expanded)
      );

      if (mobilePanel) {
        mobilePanel.hidden = expanded;
      }

      document.documentElement.classList.toggle(
        'ovelisco-menu-open',
        !expanded
      );
    });

    mobilePanel?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        this.closeAll();
      });
    });

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.closeAll();
      }
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeAll();
      }
    });

    document.addEventListener(
      'touchmove',
      (event) => {
        const mobileIsOpen =
          mobileToggle?.getAttribute('aria-expanded') === 'true';

        if (
          mobileIsOpen &&
          mobilePanel &&
          !mobilePanel.contains(event.target)
        ) {
          this.closeAll();
        }
      },
      {
        passive: true,
        capture: true
      }
    );

    document.addEventListener(
      'scroll',
      (event) => {
        const mobileIsOpen =
          mobileToggle?.getAttribute('aria-expanded') === 'true';

        if (
          mobileIsOpen &&
          mobilePanel &&
          event.target !== mobilePanel &&
          !mobilePanel.contains(event.target)
        ) {
          this.closeAll();
        }
      },
      true
    );

    window.addEventListener(
      'scroll',
      () => {
        const mobileIsOpen =
          mobileToggle?.getAttribute('aria-expanded') === 'true';

        if (mobileIsOpen) {
          this.closeAll();
        }
      },
      {
        passive: true
      }
    );
  }

  closeAll() {
    this.querySelectorAll('[data-ovelisco-menu]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });

    this.querySelectorAll('.ovelisco-mega').forEach((panel) => {
      panel.hidden = true;
    });

    const mobileToggle = this.querySelector(
      '[data-ovelisco-mobile]'
    );

    const mobilePanel = this.querySelector(
      '[data-ovelisco-mobile-panel]'
    );

    mobileToggle?.setAttribute('aria-expanded', 'false');

    if (mobilePanel) {
      mobilePanel.hidden = true;
    }

    document.documentElement.classList.remove(
      'ovelisco-menu-open'
    );
  }
}

if (!customElements.get('ovelisco-header')) {
  customElements.define('ovelisco-header', OveliscoHeader);
}